export default "__VITE_ASSET__47cbc7dd__"